<template>
  <div class="f14-l19 h-100 d-flex" :class="alignment">
    <div class="d-flex flex-row " :class="alignment">
      <input type="hidden" :name="field.data_name" v-model="checklist">
      <div v-if="field.options" class="align-items-center asmessage  d-flex flex-row position-relative small-space">
        <div class="accordion-header pointer" @click="showOptions">{{field.label || "missing label"}}</div>
        <CaretComponent :open="optionsVisible" @click="showOptions" />
        <div v-show="optionsVisible">
          <div class="d-flex flex-column innerpopup" :ref="(el) => {this.innerPopupRef=el;}">
            <div v-for="(option,idx) in field.options" :key="`option--${idx}`" class="d-flex flex-row align-items-center">
              <input type="checkbox" class="red-checkbox" :id="option.tag_id_prefix + `_${idx}_` + option.tag_value" autocomplete="off" :value="option.search_val" v-model="checklist">
              <label class="btn btn1 text-right d-flex flex-column f14-l18 nowrap" :for="option.tag_id_prefix + `_${idx}_` + option.tag_value">
                {{ option.text }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="align-items-center asmessage yellow-message d-flex flex-row position-relative small-space pointer" @click="submitSingleButton(field.val)">{{field.label || "missing label"}}</div>
        <FormHiddenFieldComponent type="hidden" :name="field.data_name" :value="this.singleButtonValue" />
      </div>
    </div>
    <BGClickCatcherComponent v-show="optionsVisible" @click="() => {this.optionsVisible = false}" />
  </div>
</template>
<script>
import CaretComponent from "@/components/CaretComponent";
import BGClickCatcherComponent from "@/components/popup/BGClickCatcherComponent";
import FormHiddenFieldComponent from "@/components/form/FormHiddenFieldComponent"
export default {
  components: {
    CaretComponent,
    BGClickCatcherComponent,
    FormHiddenFieldComponent
  },
  data() {
    return {
      optionsVisible: false,
      showit: false,
      checklist: [],
      innerPopupRef: null,
      singleButtonValue: "1",
    }
  },
  props: {
    field: Object
  },
  methods: {
    async showOptions() {
      this.optionsVisible = !this.optionsVisible;
      await this.$nextTick();
      if (this.innerPopupRef.getBoundingClientRect().x<0) {
        this.innerPopupRef.classList.add("innerpopup-left");
        this.innerPopupRef.classList.remove("innerpopup");
      }
    },
    openSelectCity() {
      if ("select_city_popup" == this.availability?.on_click) {
        this.$store.dispatch('showSelectCity');
      }
    },
    submitSingleButton(value) {
      this.singleButtonValue = this.singleButtonValue == this.field.val ? "0" : this.field.val;
      this.$emit("change", value);
    }
  },
  computed: {
    alignment() {
      if (this.$isDesktop()) {
        return "justify-content-center align-items-center";
      }
      return "align-items-right";
    },
  },
  watch: {
    async checklist(value) {
      // if (process.env.NODE_ENV === 'development') {
      //   console.log(this.field.data_name + ":" + this._.uid + ":" + value);
      // }
      this.optionsVisible = false;
      this.$emit("changed", value);
    }
  },
}
</script>
<style scoped>
.asmessage {
  border: 1px solid #bbbaba;
  border-radius: 20px;
  background: white;
  margin-left: 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  padding: 0 5px 0 5px;
}

.yellow-message {
  background: yellow;
}

.innerpopup {
  z-index: 4000;
  background: white;
  position: absolute;
  right: 0;
  top: 25px;
  border: 1px solid #ccc;
  padding: 20px 20px;
}

.innerpopup-left {
  z-index: 4000;
  background: white;
  position: absolute;
  left: 0;
  top: 25px;
  border: 1px solid #ccc;
  padding: 20px 20px;
}

.carousel .innerpopup {
  top: inherit;
  bottom: 25px;
}

.small-space {
  margin-left: 5px;
}
</style>